module.exports = __webpack_public_path__ + "static/media/dst-off@2x.e9a96f72.webp";